import { render, staticRenderFns } from "./view.vue?vue&type=template&id=0431d69b"
import script from "./view.ts?vue&type=script&lang=js&external"
export * from "./view.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0431d69b')) {
      api.createRecord('0431d69b', component.options)
    } else {
      api.reload('0431d69b', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=0431d69b", function () {
      api.rerender('0431d69b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/duplicacoes/prescritoresDuplicados/view.vue"
export default component.exports